import React from 'react'
import { getVariable } from '../service/asccp';

const Recommendation = ({ content, references, togglePDF, referenceNumber, exStyles }) => {

    let c = content;
    let recommendation = "";

    if (c.name || c.title) {
        recommendation = recommendation + "<small><i>" + (c.name || c.title) + "</i></small><br><br>";
    }

    recommendation = recommendation + "<b>" + c.text + "</b>" + referenceNumber(references, c.reference);

    if (c.followup && c.followup.length > 0) {
        let followup = c.followup;
        if (followup.indexOf("follow-up visit") < 0) {
            followup += " at follow-up visit.";
        }

        recommendation = recommendation + "<br><br>" + followup + referenceNumber(references, c.followup_reference);
    }

    if (c.info && c.info.length > 0) {
        c.info.forEach(i => {
            recommendation = recommendation + "<br><br>";
            recommendation = recommendation + i.text + referenceNumber(references, i.reference) + " ";
        });
    }

    let risk_info = "";
    if (c.risk_info && c.risk_info.length > 0) {
        risk_info = "<br>";
        c.risk_info.forEach(i => {
            risk_info = risk_info + i.text + referenceNumber(references, i.reference) + " ";
        });
    }


    if (c.risk === 'Special Situation') {

        return (
            <div className="card card-rec">
                <div className="card-body">
                    <div style={{ display: "none" }}>
                        <pre>{JSON.stringify(c, null, 2)}</pre>
                    </div>
                    <div>
                        <h6 className="card-subtitle mt-2 mb-2 text-muted" dangerouslySetInnerHTML={{ __html: recommendation }} />
                        <h6 className="card-subtitle mb-2 text-muted">
                            <div>
                                Risk is not shown due to special situation.<span dangerouslySetInnerHTML={{ __html: referenceNumber(references, c.risk_reference) }}></span><br /><br />
                                Special Situations apply when data is limited, or risk of cancer is disproportionately high.
                            </div>
                        </h6>
                    </div>
                </div>
                {c.uid && document.location.hostname.endsWith("asccp.org") == false ?
                    <div><h6><strong>ID {c.uid}</strong></h6></div> : ""}
            </div>
        );
    }
    else if (c.risk_of &&
        c.risk &&
        c.risk_of !== '' &&
        c.risk !== '') {

        var c0 = "r0"; var t0 = "5 Year Return"; var p0 = "0.0%";
        var c1 = "r1"; var t1 = "3 Year Return"; var p1 = "0.15%";
        var c2 = "r2"; var t2 = "1 Year Return"; var p2 = "0.55%"; var p3 = "9.0%";
        if (c.risk_of == "Immediate risk of CIN3+") {
            c0 = "r3"; t0 = "COLPOSCOPY\n(Recommended)"; p0 = "4.0%";
            c1 = "r4"; t1 = "Expedited Treatment or\nColposcopy Acceptable"; p1 = "25%";
            c2 = "r5"; t2 = "Expedited Treatment\nPreferred"; p2 = "60%"; p3 = "100%";
        }

        return (
            <div>
                <div className="card card-rec">
                    <div className="card-body">
                        <div style={{ display: "none" }}>
                            <pre>{JSON.stringify(c, null, 2)}</pre>
                        </div>
                        <div>
                            <h6 className="card-subtitle mt-2 mb-2 text-muted" dangerouslySetInnerHTML={{ __html: recommendation }} />
                        </div>
                    </div>
                    {c.uid && document.location.hostname.endsWith("asccp.org") == false ?
                        <div><h6><strong>ID {c.uid}</strong></h6></div> : ""}
                </div>
                <div className="card card-rec">
                    <div className="card-body">
                        <h5 className="card-title text-muted">Risk</h5>
                        <div>
                            <table id="risk_bar" className={exStyles}>
                                <tbody>
                                    <tr>
                                        <td className={c0 + ' label'}>{t0}</td>
                                        <td className={c1 + ' label'}>{t1}</td>
                                        <td className={c2 + ' label'}>{t2}</td>
                                    </tr>
                                    <tr>
                                        <td className={c0 + ' left'}></td>
                                        <td className={c1 + ' middle'}></td>
                                        <td className={c2 + ' right'}></td>
                                    </tr>
                                    <tr>
                                        <td className={c0 + ' text'}>{p0}</td>
                                        <td className={c1 + ' text'}>{p1}</td>
                                        <td className={c2 + ' text'}>{p2}<span style={{ float: "right" }}>{p3}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <h6 className="card-subtitle mb-2 text-muted text-center">
                                {c.risk_of} is&nbsp;
                                {c.risk_figure ?
                                    (<a className="link" onClick={e => togglePDF(c.risk_figure)}><b>{c.risk}</b><span dangerouslySetInnerHTML={{ __html: referenceNumber(references, c.risk_reference) }}></span></a>) :
                                    (<span><b>{c.risk}</b><span dangerouslySetInnerHTML={{ __html: referenceNumber(references, c.risk_reference) }}></span></span>)
                                }
                                <div dangerouslySetInnerHTML={{ __html: risk_info }}></div>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {

        if (c.style) {
            return (
                <div className="question question-content" key={c.title}>
                <h3 className={c.style + " selected"}>{c.title}</h3>
                <h6 className='card-subtitle mt-3 text-muted'>
                    <span dangerouslySetInnerHTML={{ __html: c.text }} />
                </h6>
            </div>
            );
        }

        return (
            <div className="card card-rec">
                <div className="card-body">
                    <div style={{ display: "none" }}>
                        <pre>{JSON.stringify(c, null, 2)}</pre>
                    </div>
                    <div>
                        <h6 className="card-subtitle mt-2 mb-2 text-muted" dangerouslySetInnerHTML={{ __html: recommendation }} />
                    </div>
                </div>
                {c.uid && document.location.hostname.endsWith("asccp.org") == false ?
                    <div><h6><strong>ID {c.uid}</strong></h6></div> : ""}
            </div>

        );
    }
};

export default Recommendation